exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-link {\n  color: #3b5998; }\n\n.contact-info {\n  padding: 10px;\n  display: -ms-grid;\n  display: grid;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 10px; }\n\n.info-item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  color: #3b5998; }\n  .info-item i {\n    font-size: 24px;\n    color: #3b5998; }\n  .info-item span {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    gap: 2px; }\n  .info-item .fa-volume-control-phone {\n    -ms-transform: rotate(-40deg);\n        transform: rotate(-40deg);\n    transition: transform 0.3s ease; }\n\n.icofont-headphone-alt-2 {\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/trip2-theme/components/t2-help/t2-help.component.scss
// module id = 2151
// module chunks = 66